// 每个页面除了首页添加倒计时
import Vue from 'vue';
import CountTime from '@/page/CountTime.vue'

// 1.使用基础vue构造器，创建一个"子类"
const countTIme = Vue.extend(CountTime)
const countModalBox=(options={})=>{
    // 2.创建实例
    let instance = new countTIme();//无传参
    // 有参数创建实例
    // let instance = new countTIme({
    //     data:{
    //         ...options//有传参
    //     }
    // })
    // 3.实例构造器挂载在页面上
    instance.$mount();
    // 4.通过$el属性来访问创建的组件实例
    console.log(document.body.id)
    // if(document.body.id!='container'){
        document.body.appendChild(instance.$el);
    // }
    
    console.log('instance:',instance)
    return instance;
}
// 5.两种方式将逻辑函数进行暴露，并且在main.js引入挂载在全局
// 5.1 Vue.prototype直接暴露
export default countModalBox;
// 5.2 vue.use的install()暴露对象
// export default{
//     install:(Vue)=>{
//         Vue.prototype.$countTIme=countModalBox
//     }
// }





